<template>
  <div class="toolbar-content">
    <div
      class="toolbar-title"
      :class="['padding-' + padding]"
    >
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    padding: {
      type: Number,
      default: 1
    }
  }
}
</script>
<style>

.toolbar {
  padding: 4px 12px;
  min-height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  width: 100%;
  position: relative;
  color: #fff;
  background: #027BE3;
}
.toolbar > button {
  margin: 0 0.2rem;
  padding: 0.2rem;
  text-shadow: none;
}
.toolbar > button:active:not(.disabled) {
  color: #027BE3;
}
.toolbar i {
  line-height: 1;
}
.toolbar-content {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-width: 0;
  max-width: 100%;
}
.toolbar-title {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  font-size: 1.15rem;
  font-weight: 500;
}
.toolbar-title > div {
  padding: 0 12px;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
